
import Navbar from '../Navbar/navbar'
import Footer from '../Footer/footer'
import icons from '../../icons.config';
import { useState,useEffect } from 'react';
import images from '../../images.config';
import FooterDoodles from '../Footer/footerDoodles';
import { fetchFAQs,submitContactForm } from '../../Providers/contactUsProvider';
import TrackOrderPopup from '../ProfilePage/modals/trackOrderPopup';
import SizeGuidePopup from '../ProductPage/modals/sizeGuidePopup';

function ContactUs() {
 
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  // Fetch FAQs from contactUsProvider.js
  useEffect(() => {
    const getFAQs = async () => {
      const faqData = await fetchFAQs();
      setFaqs(faqData.data);
    };
    getFAQs();
  }, []);

  // Toggle FAQ visibility
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit contact form using contactUsProvider.js function
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitContactForm(formData);
      alert('Message sent successfully!');
      setFormData({ name: '', email: '', phone: '', message: '' }); // Reset form
    } catch (error) {
      alert('Failed to send message. Please try again later.');
    }
  };

  const [showTrackOrderPopup, setShowTrackOrderPopup] = useState(false);
  const [isSizeGuideOpen, setIsSizeGuideOpen] = useState(false);

  const toggleSizeGuide = () => {
    setIsSizeGuideOpen((prev) => !prev);
  };
  return (
    <>
    <Navbar/>
    <div className=" bg-tertiary relative  pt-5 pb-0 xl:max-h-screen overflow-hidden">
    <div className="relative lg:left-[81%] xl:left-[80%] left-[68%] md:left-[77%] top-7 lg:-top-7 xl:-top-4 z-10">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-32 md:w-48 lg:w-1/5" />
        </div>
  <div className="flex flex-col lg:flex-row px-11 md:px-10 lg:px-24 xl:px-32 relative bottom-5 lg:bottom-14 xl:bottom-32 overflow-hidden">
    
    {/* Left Section - General Queries Image */}
    <div className="w-full lg:w-1/3 flex flex-col justify-center items-center mb-6 lg:mb-0">
  <div className="w-full h-full bg-gray-300 rounded-lg flex items-center justify-center">
    <img 
      src={images.founder1} 
      alt="General Queries" 
      className="object-cover w-full h-[96%] "
    />
  </div>

  <div className="flex flex-col space-y-2 md:space-y-0 md:flex-row lg:flex-col xl:flex-row justify-between md:space-x-16 lg:space-x-8  mt-3 md:mt-7 relative w-full bottom-1"> {/* Flex container for buttons */}
    <button className="w-full  bg-hcolor text-tertiary border-2 border-hcolor  hover:bg-tertiary hover:text-hcolor  px-20 md:px-7 xl:px-4 text-nowrap py-2 transition duration-300 relative lg:bottom-3 xl:bottom-0" onClick={toggleSizeGuide}>
      VIEW SIZE GUIDE
    </button>
    <button className="w-full  bg-tertiary text-hcolor border-2 border-hcolor  md:hover:bg-hcolor md:hover:text-primary2 px-20 md:px-9 lg:px-10 xl:px-7 relative right-0 lg:right-8 xl:right-0 lg:top-0 xl:top-0  py-2 text-nowrap transition duration-300" onClick={()=>setShowTrackOrderPopup(true)}>
     TRACK ORDER
    </button>
  </div>
</div>
 {/* Conditionally render the popup */}
 {showTrackOrderPopup && (
        <TrackOrderPopup onClose={() => setShowTrackOrderPopup(false)} />
      )}
        {/* Show SizeGuidePopup without the trigger button */}
        <SizeGuidePopup isOpen={isSizeGuideOpen} togglePopup={toggleSizeGuide} showTrigger={false} />
    {/* Right Section - Form */}
    <div className="w-full lg:w-2/3 lg:pl-6 ">
      <h2 className="text-4xl font-light font-outfit mb-7">QUERY ?</h2>
      
      {/* Input Fields Row (Name and Email) */}
      <div className="flex flex-col space-y-11 md:space-y-0 md:flex-row md:space-x-7 mb-6">
        <div className="w-full relative left-1 md:w-1/2">
        <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter Your Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 pt-2 border-2 placeholder:font-poppins placeholder:font-normal placeholder:text-sm bg-tertiary border-primary1 rounded-lg focus:outline-none  bg-transparent text-gray-500  peer focus:text-hcolor focus:font-normal focus:font-outfit"
              required
            />
            <label
              htmlFor="name"
              className="absolute left-3 px-2 bg-tertiary text-primary1 bg-cream text-lg font-medium pointer-events-none  transform -translate-y-4 scale-75 top-1 z-10 origin-[0] start-4"
            >
              NAME
            </label>
        </div>
        <div className="relative left-1 w-full md:w-1/2 ">
        <input
              type="text"
              id="email"
              name="email"
              placeholder="Enter Your Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full placeholder:font-poppins placeholder:font-normal placeholder:text-sm p-2 pt-2 border-2 border-primary1 rounded-lg focus:outline-none  bg-tertiary text-gray-500  peer focus:text-hcolor focus:font-normal focus:font-outfit"
              required
            />
            <label
              htmlFor="email"
              className="absolute bg-tertiary left-3 px-2 text-primary1 bg-cream text-lg font-medium pointer-events-none  transform -translate-y-4 scale-75 top-1 z-10 origin-[0] start-4"
            >
              EMAIL
            </label>
        </div>
      </div>

      {/* Phone Number and Submit Button Row */}
      <div className="flex flex-col md:flex-row md:space-x-4 mb-10">
          <div className="relative left-1 w-full md:w-1/2 mt-4">
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="Enter Your Phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full placeholder:font-poppins placeholder:font-normal placeholder:text-sm p-2 pt-2 border-2 bg-tertiary border-primary1 rounded-lg focus:outline-none  bg-transparent text-gray-500  peer focus:text-hcolor focus:font-normal focus:font-outfit"
              required
            />
            <label
              htmlFor="phone"
              className="absolute left-3 bg-tertiary px-2 text-primary1 bg-cream text-lg font-medium pointer-events-none  transform -translate-y-4 scale-75 top-1 z-10 origin-[0] start-4 "
            >
              PHONE
            </label>
          </div>



          <div className="hidden lg:flex w-1/2 mt-4 md:mt-0  items-end justify-end ">
  <button className="flex items-center pl-11 pr-8 py-1 bg-hcolor text-tertiary hover:bg-tertiary hover:text-hcolor border-2 border-hcolor transition duration-300 hover:text-xl hover:font-semibold" onClick={handleSubmit}>
    SUBMIT
    <img 
      src={icons.contactArrow} // Replace with your arrow image path
      alt="Arrow"
      className="ml-3 w-8 h-8 " // Adjust size as needed
    />
  </button>
</div>

      </div>

      {/* Textarea Field */}
      <div className="relative left-1 mb-0">
        <label className="absolute left-3 bg-tertiary px-2 text-primary1 bg-cream text-lg font-medium pointer-events-none  transform -translate-y-4 scale-75 top-1 z-10 origin-[0] start-4">MESSAGE</label>
        <textarea 
          placeholder="Write your message..." 
          rows="8"
          name="message"
          value={formData.message}
          onChange={handleChange}
          className="w-full placeholder:font-poppins placeholder:font-normal placeholder:text-sm p-2 pt-2 border-2 bg-tertiary border-primary1 rounded-xl focus:outline-none  bg-transparent text-gray-500  peer focus:text-hcolor focus:font-normal focus:font-outfit"
              
        ></textarea>
      </div>
      <div className=" relative left-2 lg:hidden w-full mt-4 md:mt-5  items-end justify-end ">
  <button className="flex items-center pl-11 pr-8 py-1 bg-hcolor text-tertiary hover:bg-tertiary hover:text-hcolor border-2 border-hcolor transition duration-300 hover:text-xl hover:font-semibold" onClick={handleSubmit}>
    SUBMIT
    <img 
      src={icons.contactArrow} // Replace with your arrow image path
      alt="Arrow"
      className="ml-3 w-8 h-8 " // Adjust size as needed
    />
  </button>
</div>
    </div>
  </div>
</div>




    <div className='pt-28 pb-6 bg-tertiary relative top-0 overflow-x-hidden '>
      
    <div className="relative bottom-4 md:top-0 lg:-top-20 left-[5%] lg:left-[2%] z-20 h-10 py-3">
          <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-16 md:w-20 lg:w-28 " />
        </div>
        <div className='relative overflow-hidden'>
    <div className="max-w-[81%] mx-auto   ">
  <h2 className="text-3xl font-light font-outfit text-center mb-16 relative bottom-1">FAQs</h2>
  <div className="space-y-10">
    {faqs.map((faq, index) => (
      <div key={index} className="border-b border-primary2 pb-5 ">
        {/* Question Section */}
        <div 
          className="flex justify-between items-center cursor-pointer" 
          onClick={() => toggleFAQ(index)} // Toggle answer visibility on click
        >
          <h3 className="text-lg font-normal text-primary1">{faq.question}</h3>
          {/* Toggle between plus and minus icons */}
          {activeIndex === index ? (
            <img src={icons.minus} alt="collapse" className='text-primary1 font-light w-4 h-2' />
          ) : (
            <img src={icons.plus} alt="expand" className='text-primary1 font-light w-7 h-7'/>
          )}
        </div>

        {/* Answer Section - only show if active */}
        <div
          className={`overflow-hidden transition-all duration-500 ease-in-out  ${
            activeIndex === index ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <p className="mt-3 text-hcolor max-w-[80%]">
            {faq.answer}
          </p>
        </div>
      </div>
    ))}
  </div>
</div>
</div>
<div className="relative lg:left-[89%] left-[80%] md:left-[84%] -top-9 md:top-8 lg:top-6 z-20  ">
          <img src={icons.blogFlower2} alt="Doodle Left" className="w-16 md:w-20 lg:w-28" />
        </div>

</div>


    
    <FooterDoodles/>
    <Footer/>
    </>
  )
}

export default ContactUs